const columns = [
  {
    title: "Staff",
    dataIndex: "display_name",
    scopedSlots: { customRender: "display_name" },
    fixed: "left",
    width: 300,
  },
  {
    title: "Date",
    dataIndex: "date",
    name: "date",
    width: 150,
  },
  {
    title: "Type",
    dataIndex: "type",
    name: "type",
    width: 250,
  },
  {
    title: "Time (Hours)",
    dataIndex: "time",
    name: "time",
    width: 150,
  },
  {
    title: "Description",
    dataIndex: "description",
    name: "description",
    width: 200,
    ellipsis: true,
  },
  {
    title: "Created By",
    dataIndex: "created_by",
    name: "created_by",
    scopedSlots: { customRender: "created_by" },
    width: 200,
  },
  {
    title: "Action",
    dataIndex: "edit",
    scopedSlots: { customRender: "edit" },
    align: "center",
    fixed: "right",
    width: 80,
  },
];

import FilterLayout from "../../components/layouts/FilterLayout";
import { mapState } from "vuex";
import moment from "moment";
import {
  convertObjectToParams,
  formatDate,
  formatTime,
  downloadFile,
  scaleScreen,
  initFilters,
  checkShowWithLastTimesheet,
  getMessages,
} from "../../components/commons/commons";
import {
  DATE_FORMAT_DMY,
  DATE_FORMAT_FULL,
  DATE_FORMAT_SHORT,
  TIME_STAFF,
} from "../../components/commons/commonConstant";
import { Role } from "../../components/commons/commonConstant";
import http from "../../store/modules/helpers/httpInterceptor";

export default {
  name: "SpecialExplanation",
  components: { FilterLayout },
  data() {
    return {
      page: "Special Explanation",
      currentScreen: "special_explanation",
      columns,
      id: 0,
      dataSource: [],
      recordSelected: {},
      pagination: {},
      filterKey: 1,
      currentPage: 1,
      pageSize: 10,
      total_items: 0,
      dataFilters: {},
      DATE_FORMAT_DMY,
      moment,
      filters: {},
      Role,
      firstCall: true,
      visibleDropDown: false,
      formData: {
        id: null,
        request_type: "",
        reason_type: "",
        date: undefined,
        listEmployee: [],
        time: "",
        description: "",
        created_date: "",
        is_from_sf4c: false,
        last_modified: "",
        cc: [],
      },
      cc_mail: [],
      formRQ: this.$form.createForm(this, { name: "Request" }),
      visibleModal: false,
      visibleModalImport: false,
      isEdit: false,
      reasons: [],
      types: [],
      tempCheckDate: [],
      request_reasons: [],
      fetching: false,
      isCreated: false,
      tempMail: "",
      statusPayload: [],
      disableExport: true,
      timeOut: null,
      size: window.outerWidth > 1000 ? window.outerWidth * 0.6 : window.outerWidth * 0.55,
      fileList: [],
      isAvaiableToDownLoad: false,
      request_type: "request",
      disabledButton: false,
    };
  },
  watch: {
    visible: function() {
      this.myFunction();
    },
    // formData: function () {
    //   this.formRQ.setFieldsValue(
    //     this.formData
    //   )
    // },
    filters: function() {
      if (this.filters.fromDate !== undefined && this.filters.toDate !== undefined) {
        this.disableExport = false;
      } else {
        this.disableExport = true;
      }
    },
    visibleModal(newValue) {
      if (newValue === false) {
        this.salary = "";
        this.formData = {};
        this.birthdayLeave = false;
        this.visibleModal = false;
        this.isTimeOff = false;
        this.disabledButton = false;
        this.cc_mail = [];
      }
    },
    visibleModalImport(newValue) {
      if (newValue === false) {
        this.visibleModalImport = false;
        this.fileList.splice(0, this.fileList.length - 1);
      }
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "dynamic_form_item" });
    this.form.getFieldDecorator("keys", { initialValue: [], preserve: true });
  },
  created() {
    this.scaleScreen();
    this.handFilters();
    this.firstCall = true;
    this.getLastTimesheetInfo();
    window.addEventListener("resize", this.resize);
    // Get Time Server
    this.$store.dispatch("application/getTimeServer");
  },
  computed: {
    ...mapState({
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      employeeList: (state) => state.application.employeeList,
      // specialExplanationList: (state) => state.specialExplanation.specialExplanationList.data,
      userInfo: (state) => state.user.userInfo,
      dataRequestSelections: (state) => state.request.dataRequestSelections,
      lastTimesheet: (state) => state.application.lastTimesheet,
      loading: (state) => state.user.loading,
      timeServer: (state) => state.application.timeServer,
    }),
  },
  mounted() {},

  methods: {
    formatDate,
    formatTime,
    scaleScreen,
    checkPermissionCreate() {
      return this.roles.includes(Role.HR) || this.roles.includes(Role.HRM);
    },
    getMessages(message) {
      let messages = [];
      if (message && Array.isArray(message)) {
        message.forEach((msg) => messages.push(msg));
      } else {
        messages.push(message);
      }
      return messages;
    },
    handFilters() {
      const { filters, currentScreen, userInfo } = this;
      initFilters(filters, currentScreen, userInfo);
      // if (sessionStorage.getItem(this.page)) {
      //   this.filters = { ...JSON.parse(sessionStorage.getItem(this.page)) };
      // } else {
      //   this.filters = {
      //     ...this.filters,
      //     ...JSON.parse(sessionStorage.getItem(this.page)),
      //   };
      // }
    },
    resize() {
      if (document.body.clientWidth > 1000) {
        this.size = document.body.clientWidth * 0.6;
      } else {
        this.size = document.body.clientWidth * 0.55;
      }
    },
    handleImport() {
      this.visibleModalImport = true;
    },
    exportRequest() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        const { filters } = this;
        const paramFilter = convertObjectToParams({
          ...filters,
        });
        this.$store.dispatch("user/loadingRequest");
        http
          .get(`tms/excel/request-list${paramFilter}`, { responseType: "blob" })
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              downloadFile(
                res.data,
                `Request_List_${moment(filters.fromDate).format("DD/MM/yyyy")}-${moment(filters.toDate).format(
                  "DD/MM/yyyy"
                )}.xlsx`
              );
              this.$store.dispatch("user/loadingRequest");
              this.$message.success("Request List is exported successfully!", 5);
            } else {
              this.$store.dispatch("user/loadingRequest");
              this.$message.error("No data export", 5);
            }
          })
          .catch((err) => {
            this.$store.dispatch("user/loadingRequest");
            this.$message.error(err.response.data.error, 5);
          });
      }, 500);
    },
    checkResOnclickEdit(i, res) {
      if (res.data) {
        this.request_reasons = res.data.request_reason;
        this.formData.request_type = i.request_type;
        this.shiftData = res.data.types;
        this.request_reasons.forEach((request) => {
          if (request.request_type === i.request_type_name) {
            this.reasons = request.reasons;
            this.formData.reason_type = i.reason_type;
          }
        });
      } else {
        this.$message.error(res.message, 5);
      }
    },
    async handleOnClickEdit(record) {
      this.fileList.splice(0, this.fileList.length);
      this.recordSelected = record;
      // this.getAllListFile(i.id);
      if (this.checkPermissionCreate()) {
        await this.getInfoModal();
        this.cc_mail = [];
        this.tempMail = "";
        this.formData = {
          time: record.time.toString(),
          description: record.description,
          listEmployee: [record.employeeId],
          date: record.date ? moment(record.date, DATE_FORMAT_DMY) : undefined,
        };
        if (record.ccMailInfor.length > 0) {
          record.ccMailInfor.forEach((element) => {
            this.cc_mail.push(element.employeeId);
            this.tempMail = this.tempMail + element.username + " ";
          });
        }
        if (record.username) {
          this.tempMail = this.tempMail + " " + record.username + " ";
        }
      } else {
        this.$message.error("You do not have permission to create", 5);
      }
    },
    async showModalEdit() {
      this.$store.dispatch("user/loadingRequest");
      await this.onSearchStaff(this.tempMail);
      setTimeout(() => {
        this.visibleModal = true;
        this.isEdit = true;
        this.$store.dispatch("user/loadingRequest");
      }, 2000);
    },

    onApplyFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.getSpecialExplanation();
    },
    onSetDataFilters(filters) {
      this.filters = filters;
    },
    onClose() {
      this.visibleDrawer = false;
    },
    showModalCreate() {
      this.formData = {};
      this.formRQ.resetFields();
      this.fileList.splice(0, this.fileList.length);
      this.formRQ.resetFields();
      this.getInfoModal();
      this.$store.dispatch("user/loadingRequest");
      setTimeout(() => {
        this.visibleModal = true;
        this.isEdit = false;
        this.$store.dispatch("user/loadingRequest");
      }, 1000);
    },
    async getInfoModal() {
      this.$store
        .dispatch("request/getParamsDataToSelect")
        .then((res) => {
          if (res.data) {
            this.request_reasons = res.data.request_reason;
            this.reasons = res.data.request_reason.find(
              (item) => item.request_type_code === "SPECIAL_EXPLANATION"
            ).reasons;
            this.formData.request_type = "SPECIAL_EXPLANATION";
            this.formData.reason_type = "NOT_ENOUGH_WORKING_HOURS_BY_BUS";
          }
        })
        .catch(() => {
          this.$message.error("Open modal create request fail!");
        });
    },
    handleCancel() {
      this.formRQ.resetFields();
      this.formData = [];
      this.visibleModal = false;
      this.visibleModalImport = false;
      this.fileList.splice(0, this.fileList.length);
      this.ccMail = [];
    },
    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      if (value && value !== "" && value.length >= 3) {
        this.fetching = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$store
            .dispatch("application/getEmployeeList", cloneVal)
            .then(() => {
              this.fetching = false;
            })
            .catch(() => {
              this.fetching = false;
            });
        }, timeout);
      }
    },
    onChangeCCValue(value) {
      this.cc_mail = value;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onChangePage(page, pageSize) {
      this.currentPage = page;
      this.pageSize = pageSize;
      this.getSpecialExplanation();
    },
    getSpecialExplanation() {
      this.$store.dispatch("user/loadingRequest");
      const { currentPage, pageSize, filters } = this;
      let param = {};
      if (this.firstCall) {
        param = {
          ...filters,
          page: 1,
          size: 10,
        };
        this.currentPage = filters.page ? filters.page : 1;
        this.pageSize = filters.size ? filters.size : 10;
      } else {
        param = {
          ...filters,
          page: currentPage,
          size: pageSize,
        };
      }
      const url = convertObjectToParams(param, "special_explanation");
      this.$store
        .dispatch("specialExplanation/getSpecialExplanationData", url)
        .then((res) => {
          const data = res.data;
          if (data) {
            this.total_items = res.page.total_element;
            this.dataSource = data;
            this.firstCall = false;
          } else if (res.message !== null && res.message !== "") {
            this.$message.error(res.message, 5);
          }
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },
    checkCreate(res) {
      if (parseInt(res.code) === 201 || parseInt(res.code) === 200) {
        getMessages(res?.message).forEach((msg) => {
          this.$message.success(msg, 5);
        });
        this.formRQ.resetFields();
        this.visibleModal = false;
        setTimeout(() => {
          this.$store.dispatch("user/loadingRequest");
        }, 1000);
        this.getSpecialExplanation();
      } else {
        this.$store.dispatch("user/loadingRequest");
        this.disabledButton = false;
        getMessages(res.message).forEach((msg) => {
          this.$message.error(msg, 5);
        });
      }
    },
    checkUpdate(res) {
      if (res) {
        if (parseInt(res.code) === 200) {
          getMessages(res?.message).forEach((msg) => {
            this.$message.success(msg, 5);
          });
          this.formRQ.resetFields();
          this.visibleModal = false;
          setTimeout(() => {
            this.$store.dispatch("user/loadingRequest");
          }, 1000);
          this.getSpecialExplanation();
        } else {
          this.disabledButton = false;
          this.$store.dispatch("user/loadingRequest");
          getMessages(res.message).forEach((msg) => {
            this.$message.error(msg, 5);
          });
        }
      }
    },
    callApi(values) {
      let createDate = moment(new Date()).format(DATE_FORMAT_DMY);
      let data = {
        requestReason: values.request_type,
        type: values.reason_type,
        description: values.description?.trim() ?? "",
        listEmployee: values.listEmployee,
        date: values.date.format(DATE_FORMAT_DMY),
        ccMail: this.cc_mail,
        time: parseFloat(values.time),
      };

      if (!this.isEdit) {
        data.createDate = createDate;
        this.$store
          .dispatch("specialExplanation/createSpecialExplanation", data)
          .then((res) => {
            this.checkCreate(res);
          })
          .catch((error) => {
            this.$store.dispatch("user/loadingRequest");
            this.disabledButton = false;
            getMessages(error.response.data.message).forEach((msg) => {
              this.$message.error(msg, 5);
            });
          });
      } else {
        data.id = this.recordSelected.id;
        this.$store
          .dispatch("specialExplanation/updateSpecialExplanation", data)
          .then((res) => {
            this.checkUpdate(res);
          })
          .catch((error) => {
            this.$store.dispatch("user/loadingRequest");
            this.disabledButton = false;
            getMessages(error.response.data.message).forEach((msg) => {
              this.$message.error(msg, 5);
            });
          });
      }
    },
    handleSubmit(e) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        e.preventDefault();
        this.$emit("click");
        this.formRQ.validateFields((err, values) => {
          if (!err) {
            this.$store.dispatch("user/loadingRequest");
            this.disabledButton = true;
            this.callApi(values);
          }
        });
      }, 300);
    },

    updateStatus(payload) {
      this.$store
        .dispatch("request/updateStatusRequest", payload)
        .then((res) => {
          if (res) {
            if (parseInt(res.code) === 200) {
              this.$message.success(res.message, 5);
              this.reasonReject = "";
              this.statusPayload = [];
              this.formRQ.resetFields();
              this.birthdayLeave = false;
            } else {
              this.$message.error(res.message, 5);
            }
          }
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        });
    },
    onClickApprove(record) {
      if (record.status_type === "PENDING") {
        let payload = {
          employee: record.employee.id,
          id: record.id,
          status_type: "Approved",
          approver: this.userInfo.userId,
        };
        this.updateStatus(payload);
      }
    },
    onClickReject(record) {
      this.statusPayload = record;
      this.visibleModalReject = true;
    },
    checkShowEdit(record) {
      return checkShowWithLastTimesheet(
        moment(record.date, DATE_FORMAT_DMY).format(DATE_FORMAT_FULL),
        this.lastTimesheet?.last_timesheet_period_end_date,
        TIME_STAFF,
        DATE_FORMAT_FULL,
        this.timeServer
      );
    },
    getLastTimesheetInfo() {
      this.$store
        .dispatch("application/getEndDateOfLastTimsheet")
        .then((res) => {
          this.getMessage(res);
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        });
    },
    getMessage(res) {
      if (!res) {
        this.$message.error(res.message, 5);
      }
    },

    disableWeekends(date) {
      const day = new Date(date).getDay();
      return day === 0 || day === 6;
    },
    disableWeekends1(date) {
      if (new Date().getDate() < this.lastTimesheet.forbidden_request_date) {
        if (
          new Date(this.lastTimesheet.last_timesheet_period_end_date).getTime() >=
          new Date(date.format(DATE_FORMAT_SHORT)).getTime()
        ) {
          return true;
        }
      } else if (new Date().getDate() === this.lastTimesheet.forbidden_request_date) {
        if (new Date().getHours() >= this.lastTimesheet.forbidden_request_time_in_hour) {
          if (
            new Date(this.lastTimesheet.last_timesheet_period_end_date).getTime() >=
            new Date(date.format(DATE_FORMAT_SHORT)).getTime()
          ) {
            return true;
          }
        }
      } else if (new Date().getDate() > this.lastTimesheet.forbidden_request_date) {
        if (
          moment(this.lastTimesheet.last_timesheet_period_end_date) &&
          moment(date) < moment(this.lastTimesheet.last_timesheet_period_end_date).endOf("day")
        )
          return true;
      }
      const day = new Date(date).getDay();
      return day === 0 || day === 6;
    },
    disableWeekends2(date) {
      if (!this.isMultipleStaffsModal) {
        if (new Date().getDate() < this.lastTimesheet.forbidden_request_date) {
          if (
            new Date(this.lastTimesheet.last_timesheet_period_end_date).getTime() >=
            new Date(date.format(DATE_FORMAT_SHORT)).getTime()
          ) {
            return true;
          }
        } else if (new Date().getDate() === this.lastTimesheet.forbidden_request_date) {
          if (new Date().getHours() >= this.lastTimesheet.forbidden_request_time_in_hour) {
            if (
              new Date(this.lastTimesheet.last_timesheet_period_end_date).getTime() >=
              new Date(date.format(DATE_FORMAT_SHORT)).getTime()
            ) {
              return true;
            }
          }
        }
        const day = new Date(date).getDay();
        const dayStart = new Date(this.formData.start_date).getTime();
        const dayLoad = new Date(moment(date).format(DATE_FORMAT_SHORT)).getTime();

        return day === 0 || day === 6 || dayLoad < dayStart;
      }
    },
    handleBlur(event) {
      if (event.target.value) {
        const numberFixed = Number.parseFloat(event.target.value).toFixed(2);
        this.formRQ.setFieldsValue({ time: numberFixed });
      } else {
        this.ConfirmForm.setFieldsValue({ otPayConfirm: 0 });
      }
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    beforeUploadFileExcel(file) {
      // type 1: application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      // type 2: application/vnd.ms-excel
      this.fileList.splice(0, this.fileList.length);
      this.fileList.push(file);
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.deleteFile(this.formData.id, file.name);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleUpload(id) {
      const { fileList } = this;
      const formData = new FormData();
      fileList.forEach((file) => {
        formData.append("file", file);
      });
      http
        .post(`/tms/request-management/${this.request_type}/${id}/upload?file`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.$message.success("Success");
          fileList.splice(0, fileList.length);
          return res.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    getAllListFile(id) {
      const { fileList } = this;
      http
        .get(`/tms/request-management/${this.request_type}/get-all-file-list?id=` + id)
        .then((res) => {
          if (res.data) {
            let tempData = res.data;
            tempData.forEach((record) => {
              fileList.push(record);
            });
            if (fileList.length > 0) {
              this.isAvaiableToDownLoad = true;
            } else {
              this.isAvaiableToDownLoad = false;
            }
            return tempData;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteFile(id, name) {
      http
        .get(`/tms/request-management/${this.request_type}/${id}/delete-file?name=` + name)
        .then((res) => {
          this.$message.success(res.data);
          if (this.fileList.length > 0) {
            this.isAvaiableToDownLoad = true;
          } else {
            this.isAvaiableToDownLoad = false;
          }
          return res.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    handleDownload() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.$emit("click");
        const { fileList } = this;
        fileList.forEach((file) => {
          http
            .get(`/tms/request-management/${this.request_type}/${this.formData.id}/download?name=` + file.name, {
              responseType: "blob",
            })
            .then((res) => {
              downloadFile(res.data, file.name);
              return res.data;
            })
            .catch((err) => {
              throw err;
            });
        });
      }, 500);
    },
    handleSubmitFile() {
      const { fileList } = this;
      if (fileList && fileList.length > 0) {
        const formData = new FormData();
        fileList.forEach((file) => {
          formData.append("file", file);
        });

        http
          .post(`/tms/explanations-special/import-excel?file`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          })
          .then((res) => {
            if (parseInt(res.headers.code) === 200 || parseInt(res.headers.code) === 201) {
              this.$store.dispatch("user/loadingRequest");
              this.visibleModalImport = false;
              setTimeout(() => {
                this.$store.dispatch("user/loadingRequest");
                this.$message.success(res.headers.message);
                downloadFile(res.data, `Report_SpecialExplanation.xlsx`);
              }, 1000);
            }

            fileList.splice(0, fileList.length);
            return res.data;
          })
          .catch((err) => {
            if (parseInt(err.response.headers.code) === 400) {
              this.$message.error(err.response.headers.message);
            }
            throw err;
          });
      } else {
        this.$message.error("File is required");
      }
    },
    handleDownloadTemplate() {
      http
        .get(`/tms/explanations-special/download-template`, {
          responseType: "blob",
        })
        .then((res) => {
          if (parseInt(res.headers.code) === 200 || parseInt(res.headers.code) === 201) {
            this.$store.dispatch("user/loadingRequest");
            this.visibleModalImport = false;
            setTimeout(() => {
              this.$message.success(res.headers.message);
              this.$store.dispatch("user/loadingRequest");
              downloadFile(res.data, `Template.xlsx`);
            }, 1000);
          }
        })
        .catch((err) => {
          if (parseInt(err.response.headers.code) === 400) {
            this.$message.error(err.response.headers.message);
          }
          throw err;
        });
    },
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
  props: {
    msg: String,
  },
};
